import { useState } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import { InputMask } from '@/components/ui/InputMask';
import { validateZipCode } from '@/features/v2/summaryForms/Validate';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const POSTAL_CODE_NAME = 'postal_code';

const InputPostalCode = ({
  name = POSTAL_CODE_NAME,
  disabled,
  autoCompleteOff = false,
}: {
  name?: string;
  disabled?: boolean;
  autoCompleteOff?: boolean;
}) => {
  const { i18n } = useLingui();
  const { trigger, watch } = useFormContext();

  const [focused, setFocused] = useState<string>('');

  const postalCode = watch(name);

  return (
    <FormField
      name={name}
      rules={{
        validate: (value: string) => validateZipCode(value),
      }}
      defaultValue={''}
      render={({ field, fieldState }) => {
        const { value, onChange, onBlur, ...restField } = field;
        return (
          <FormItem>
            <FormLabel>{i18n.t('Wpisz swój kod pocztowy')}</FormLabel>
            <FormControl>
              <InputMask
                mask="00-000"
                inputMode="numeric"
                value={value}
                autoComplete={autoCompleteOff ? 'none' : 'postal-code'}
                label={i18n.t('Kod pocztowy')}
                disabled={disabled}
                error={fieldState.error?.message}
                success={
                  focused !== field.name && !fieldState.error && field.value
                }
                onAccept={(e) => {
                  if (e === postalCode) return;
                  if (e === null) {
                    onChange('');
                    return;
                  }
                  if (e.length < value?.length) {
                    onChange(e);
                    return;
                  }
                  onChange(e);
                  if (fieldState.error) {
                    trigger(field.name);
                  }
                }}
                onBlur={() => {
                  trigger(field.name);
                  setFocused('');
                  onBlur();
                }}
                onFocus={() => setFocused(field.name)}
                {...restField}
                data-testid="input-postal-code"
              />
            </FormControl>
          </FormItem>
        );
      }}
    />
  );
};

export default InputPostalCode;
